<template>
  <div class="wscn-http404-container">
    <div class="wscn-http404">
      <div class="pic-404">
        <img class="pic-404__parent" src="../assets/images/404.png" alt="404" />
      </div>
      <div class="bullshit">
        <div class="bullshit__oops">404错误!</div>
        <div class="bullshit__headline">{{ message }}</div>
        <div class="bullshit__info">对不起，您正在寻找的页面不存在。</div>
        <div class="back">
          <router-link to="/" class="bullshit__return-home">
            返回首页
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page404',
  data() {
    return {
      ArticleID: '',
      path: '',
      paths: '',
    }
  },
  computed: {
    message() {
      return '找不到网页！'
    },
  },
  async created() {
    var ArticleNum = this.$route.query.id
    let data = { ArticleNum }
    const res = await this.$store.dispatch('_GetArticleIDByNum', data)
    this.ArticleID = res.data.Data.ArticleID
    window.location.href = this.Url + '#/digest?ArticleID=' + this.ArticleID
  },
}
</script>

<style  scoped>
.wscn-http404-container {
  transform: translate(-50%, -50%);
  position: absolute;
  top: 40%;
  left: 50%;
  .bullshit {
    text-align: center;
    line-height: 50px;
    .bullshit__oops {
      font-size: 20px;
    }
    .back {
      font-size: 30px;
      .bullshit__return-home {
        color: cadetblue;
      }
      .bullshit__return-home:hover {
        color: rgb(240, 240, 137);
      }
    }
  }
}
</style>
